var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmitBtn',{attrs:{"loading":_vm.loading,"classes":_vm.classes,"text":_vm.$t('DeleteProductReviewBtn.deleteProductReview')},on:{"click":_vm.deleteProductReview}})}
var staticRenderFns = []

export { render, staticRenderFns }